function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import _ from "lodash";
import { Form, Row, Col, Button } from "react-bootstrap";
import ButtonInputTable from "./button";
import CheckboxInputTable from "./checkbox";
import RadioInputTable from "./radio";
import { CHECKBOX, RADIO } from "./constants";

var ReactInputTableWidget = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReactInputTableWidget, _React$Component);

  function ReactInputTableWidget() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      checkbox: true
    });

    return _this;
  }

  var _proto = ReactInputTableWidget.prototype;

  _proto.renderFooterItems = function renderFooterItems() {
    return /*#__PURE__*/React.createElement(Row, {
      className: "align-items-center justify-content-md-end"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: "auto"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "link",
      size: "sm"
    }, "Add Row"), /*#__PURE__*/React.createElement(Button, {
      variant: "link",
      size: "sm"
    }, "Add Column")));
  };

  _proto.renderTable = function renderTable() {
    var _$get = _.get(this.props, "uiSchema.ui:options", {}),
        inputTableType = _$get.inputTableType;

    switch (inputTableType) {
      case CHECKBOX:
        return /*#__PURE__*/React.createElement(CheckboxInputTable, this.props);

      case RADIO:
        return /*#__PURE__*/React.createElement(RadioInputTable, this.props);

      default:
        return /*#__PURE__*/React.createElement(ButtonInputTable, this.props);
    }
  };

  _proto.render = function render() {
    var _$get2 = _.get(this.props, "schema", {}),
        title = _$get2.title;

    var _$get3 = _.get(this.props, "uiSchema.ui:options", {}),
        headerModifiable = _$get3.headerModifiable,
        columnModifiable = _$get3.columnModifiable;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, null, title), this.renderTable(), headerModifiable && columnModifiable && this.renderFooterItems());
  };

  return ReactInputTableWidget;
}(React.Component);

export default ReactInputTableWidget;